export { Recaptcha } from './Recaptcha';
export type { RecaptchaInstance, RecaptchaProps } from './Recaptcha';
